import Voltar from '../../components/voltar/voltar';
import './informativo.css'

const Informativo = () => {

  return (
    <>
      <h1 className="top-title"><Voltar />Informações</h1>
      <div className='formulario'>
        <div className="card">
          <p>Por favor, envie seus dados através da página de Integração no sistema Fortes RH.</p>
        </div>
      </div>
    </>
  );
};

export default Informativo;